/* eslint-disable */
//Our class secomCCJSHandler class

export var WSMsgFormat = {
   WSMsgEvent: {
      EstablishConnection: [
         {
            message: {
               Event: 'EstablishConnection',
               EventType: 'Request',
               SPName: 'Samwin WebAgent',
               SPIconImage: 'SPImage.ico',
               RedialSupport: 'Yes',
               OffHookSupport: 'Yes',
               MuteSupport: 'Yes',
               AudioDeviceChangesSupport: 'Yes',
               DNDOption: 'Yes',
            },
         },
      ],
      SPLoggedIn: [
         {
            message: {
               Event: 'SPLoggedIn',
               EventType: 'Request',
            },
         },
      ],
      SPLoggedOut: [
         {
            message: {
               Event: 'SPLoggedOut',
               EventType: 'Request',
            },
         },
      ],
      TerminateConnection: [
         {
            message: {
               Event: 'TerminateConnection',
               EventType: 'Request',
            },
         },
      ],
      IncomingCall: [
         {
            message: {
               Event: 'IncomingCall',
               EventType: 'Request',
               CallID: '1',
            },
         },
      ],
      InCallAccepted: [
         {
            message: {
               Event: 'InCallAccepted',
               EventType: 'Request',
               CallID: '1',
            },
         },
      ],
      CallEnded: [
         {
            message: {
               Event: 'CallEnded',
               EventType: 'Request',
               CallID: '1',
            },
         },
      ],
      InCallRejected: [
         {
            message: {
               Event: 'InCallRejected',
               EventType: 'Request',
               CallID: '1',
            },
         },
      ],
      OutgoingCall: [
         {
            message: {
               Event: 'OutgoingCall',
               EventType: 'Request',
               CallID: '1',
            },
         },
      ],
      OutCallRejected: [
         {
            message: {
               Event: 'OutCallRejected',
               EventType: 'Request',
               CallID: '1',
            },
         },
      ],
      OutCallAccepted: [
         {
            message: {
               Event: 'OutCallAccepted',
               EventType: 'Request',
               CallID: '1',
            },
         },
      ],
      CallHold: [
         {
            message: {
               Event: 'CallHold',
               EventType: 'Request',
               CallID: '1',
            },
         },
      ],
      CallFailed: [
         {
            message: {
               Event: 'CallFailed',
               EventType: 'Notification',
               CallID: '1',
               Reason: 'Network connection lost',
            },
         },
      ],
      HeldCallResumed: [
         {
            message: {
               Event: 'HeldCallResumed',
               EventType: 'Request',
               CallID: '1',
            },
         },
      ],
      MuteHeadset: [
         {
            message: {
               Event: 'MuteHeadset',
               EventType: 'Request',
            },
         },
      ],
      UnmuteHeadset: [
         {
            message: {
               Event: 'UnmuteHeadset',
               EventType: 'Request',
            },
         },
      ],
      GetSPMuteStatus: [
         {
            message: {
               Event: 'GetSPMuteStatus',
               EventType: 'Request',
               IDForResponse: '1',
            },
         },
      ],
      ActiveDeviceChanged: [
         {
            message: {
               Event: 'ActiveDeviceChanged',
               EventType: 'Request',
            },
         },
      ],
      DNDIncomingCallAccepted: [
         {
            message: {
               Event: 'DNDIncomingCallAccepted',
               EventType: 'Request',
               HSSTATUS: '1',
               CallID: '65538',
            },
         },
      ],
      SystemInformation: [
         {
            message: {
               Event: 'SystemInformation',
               EventType: 'Request',
            },
         },
      ],
      RedialLastUser: [
         {
            message: {
               Event: 'RedialLastUser',
               EventType: 'Request',
               IDForResponse: '1',
               HeadsetPath: '',
            },
         },
      ],
      OffHook: [
         {
            message: {
               Event: 'OffHook',
               EventType: 'Request',
               IDForResponse: '1',
               HeadsetPath: '',
            },
         },
      ],
      EnableLogging: [
         {
            message: {
               Event: 'EnableLogging',
               EventType: 'Request',
               LogFileName: '.',
            },
         },
      ],
      DisableLogging: [
         {
            message: {
               Event: 'DisableLogging',
               EventType: 'Request',
            },
         },
      ],
      StartConfCall: [
         {
            message: {
               Event: 'StartConfCall',
               EventType: 'Request',
               ConfID: '1',
            },
         },
      ],
      EndConfCall: [
         {
            message: {
               Event: 'EndConfCall',
               EventType: 'Request',
               ConfID: '1',
            },
         },
      ],
      ConfCallOnHold: [
         {
            message: {
               Event: 'ConfCallOnHold',
               EventType: 'Request',
               ConfID: '1',
            },
         },
      ],
      HeldConfCallResumed: [
         {
            message: {
               Event: 'HeldConfCallResumed',
               EventType: 'Request',
               ConfID: '1',
            },
         },
      ],
   },
};

export function secomCCJSHandler(SDKPort, retryInterval) {
   console.debug('secomCCJSHandler - constructor');
   this.port = SDKPort;
   this.retryInterval = retryInterval;

   this.protocol = 'wss';
   this.location = '127.0.0.1';
   this.isConnected = false;
   this.connectionTimer = null;
   this.connectionAttempts = 0;
   this.cue = [];
   this.ccws = null;
   this.eventHandlers = {};
}

//define secomCCJSHandler functions
secomCCJSHandler.prototype.onNewEvent = function (callback) {
   console.debug('secomCCJSHandler - onNewEvent');
   if (callback && typeof callback === 'function') {
      this.eventHandlers = callback;
   }
};

secomCCJSHandler.prototype.parseEvent = function (evt) {
   console.debug('secomCCJSHandler - parseEvent');
   var data = evt.data;
   console.debug(data);
   var json = JSON.parse(data);
   var m = {
      data: data,
      HeadsetPath: json.HeadsetPath,
      message: json.Event,
      type: json.EventType,
      returnCode: json.ReturnCode,
   };
   return m;
};

secomCCJSHandler.prototype.msgOut = function (m, verbose) {
   console.debug('secomCCJSHandler - msgOut');
   var data = JSON.stringify(JSON.parse(m.data), null, 1);
   secomCCJSHandler.prototype.log('<<<<<<<<<<<< ' + m.message + ' <<<<<<<<<<<<@', data);
   if (verbose) {
      secomCCWebLibObj.log('Message: ' + m.message);
      secomCCWebLibObj.log('Type: ' + m.type);
      secomCCWebLibObj.log('Return Code: ' + m.returnCode);
   }
};

secomCCJSHandler.prototype.retryConnect = function () {
   console.debug('secomCCJSHandler - retryConnect');
   secomCCWebLibObj.connectionAttempts++;
   secomCCWebLibObj.updateRetryInterval();
   secomCCWebLibObj.log(
      'Conection attempts: ' +
         secomCCWebLibObj.connectionAttempts +
         ', Retry interval: ' +
         secomCCWebLibObj.retryInterval +
         'ms'
   );
   if (secomCCWebLibObj.connectionTimer) clearTimeout(secomCCWebLibObj.connectionTimer);
   if (!this.isConnected)
      secomCCWebLibObj.connectionTimer = setTimeout(secomCCWebLibObj.initWebSocket, secomCCWebLibObj.retryInterval);
};

secomCCJSHandler.prototype.resetConnectionStatus = function () {
   console.debug('secomCCJSHandler - resetConnectionStatus');
   clearTimeout(secomCCWebLibObj.connectionTimer);
   this.connectionAttempts = 0;
   this.isConnected = true;
};

secomCCJSHandler.prototype.updateRetryInterval = function () {
   console.debug('secomCCJSHandler - updateRetryInterval');
   switch (true) {
      case this.connectionAttempts > 0 && this.connectionAttempts <= 10:
         this.retryInterval = 200;
         break;
      case this.connectionAttempts > 10 && this.connectionAttempts <= 50:
         this.retryInterval = 500;
         break;
      case this.connectionAttempts > 50 && this.connectionAttempts <= 200:
         this.retryInterval = 1000;
         break;
      default:
         this.retryInterval = 30000;
         break;
   }
};

secomCCJSHandler.prototype.messageHandler = function (evt) {
   console.debug('secomCCJSHandler - messageHandler');
   var parsedMessage = secomCCWebLibObj.parseEvent(evt);
   secomCCWebLibObj.msgOut(parsedMessage);

   if (!parsedMessage.message.match(/connected$/i)) {
      var cueItem = secomCCWebLibObj.cue.pop();
   }

   if (cueItem) {
      if (parsedMessage.message === cueItem.event) {
         secomCCWebLibObj.log(
            'Success: Expected an ' +
               cueItem.event +
               ' acknowledgement. And recieved ' +
               parsedMessage.message +
               ' acknowledgement'
         );
      } else {
         secomCCWebLibObj.log(
            'Error: Expected an ' +
               cueItem.event +
               ' acknowledgement. But recieved ' +
               parsedMessage.message +
               ' acknowledgement'
         );
      }
   }
   if (secomCCWebLibObj) {
      if (secomCCWebLibObj.eventHandlers && typeof secomCCWebLibObj.eventHandlers === 'function') {
         secomCCWebLibObj.eventHandlers(parsedMessage);
      }
      if (parsedMessage.message.match(/SocketConnected$/)) {
         secomCCWebLibObj.resetConnectionStatus();
      }
   }
};

secomCCJSHandler.prototype.initWebSocket = function () {
   try {
      console.debug('secomCCJSHandler - initWebSocket');
      secomCCWebLibObj.ccws = new WebSocket(
         secomCCWebLibObj.protocol + '://' + secomCCWebLibObj.location + ':' + secomCCWebLibObj.port
      );
      secomCCWebLibObj.ccws.onopen = function open() {
         secomCCWebLibObj.ccws.onmessage = secomCCWebLibObj.messageHandler;
         console.debug('secomCCJSHandler - onopen');
         secomCCWebLibObj.log('¤¤¤¤¤¤¤¤¤¤¤¤ onopen ¤¤¤¤¤¤¤¤¤¤¤¤@');
      };
      secomCCWebLibObj.ccws.onerror = function (evtCode) {
         console.debug('secomCCJSHandler - onerror');
         secomCCWebLibObj.log('¤¤¤¤¤¤¤¤¤¤¤¤ onerror ¤¤¤¤¤¤¤¤¤¤¤¤@');
      };
      secomCCWebLibObj.ccws.onclose = function (evtCode) {
         this.isConnected = false;
         console.debug('secomCCJSHandler - onclose');
         secomCCWebLibObj.log('|||||||||||| onclose ||||||||||||@');
         if (evtCode.code != 1000) secomCCWebLibObj.retryConnect();
      };
      return true;
   } catch (e) {
      return false;
   }
};

secomCCJSHandler.prototype.sendToCCWebLib = function (WSMessageEvent, callId) {
   console.debug('secomCCJSHandler - sendToCCWebLib');
   secomCCWebLibObj.log('@>>>>>>>>>>>> ' + WSMessageEvent + ' >>>>>>>>>>>>');
   secomCCWebLibObj.cue.push({ event: WSMessageEvent });
   var messages = {};
   messages = WSMsgFormat['WSMsgEvent'][WSMessageEvent];
   if (messages[0].message['CallID']) {
      messages[0].message['CallID'] = callId;
   }
   var msg = JSON.stringify(messages[0].message);
   this.ccws.send(msg);
};

secomCCJSHandler.prototype.close = function () {
   this.ccws.close();
};

secomCCJSHandler.prototype.open = function () {
   this.ccws.onopen();
};

secomCCJSHandler.prototype.init = function () {
   return secomCCWebLibObj.initWebSocket();
};

secomCCJSHandler.prototype.log = function (header, txt) {
   console.debug(header + ' ' + txt);
};

var secomCCWebLibObj = new secomCCJSHandler(41088, 500);
export var secomCCWebLibObj;
